import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { ProtectedRoute } from 'routes/protectedRoute.jsx';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import CategoryIcon from '@mui/icons-material/Category';
import InventoryIcon from '@mui/icons-material/Inventory';
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import * as S from './styled.js';
import Cookies from 'js-cookie';
import SettingsIcon from '@mui/icons-material/Settings';
import hiCellLogo from 'assets/hiCellLogo.png';

const ManagementTemplate = () => {
  let navigate = useNavigate();
  const onClickLogout = () => {
    Cookies.remove('authToken');
    navigate('/login');
  };

  return (
    <ProtectedRoute>
      <S.AdminContainer>
        <S.Sidebar>
          <S.Logo src={hiCellLogo} alt="Logo" />
          <div>PAINEL ADMINISTRATIVO</div>
          <S.NavItem to="/management" end>
            <HomeIcon />
            Página Inicial
          </S.NavItem>
          <S.NavItem to="/management/carousel-items">
            <ViewCarouselIcon />
            Carrossel
          </S.NavItem>
          <S.NavItem to="/management/categories">
            <CategoryIcon />
            Categorias
          </S.NavItem>
          <S.NavItem to="/management/products">
            <InventoryIcon />
            Produtos
          </S.NavItem>
          <S.NavItem to="/management/specialists">
            <SupportAgentIcon />
            Especialistas
          </S.NavItem>
          <S.NavItem to="/management/settings">
            <SettingsIcon />
            Configurações
          </S.NavItem>
          <S.LogoutButton onClick={onClickLogout}>
            <LogoutIcon />
            Sair
          </S.LogoutButton>
        </S.Sidebar>
        <S.Content>
          <Outlet />
        </S.Content>
      </S.AdminContainer>
    </ProtectedRoute>
  );
};

export default ManagementTemplate;
